/** @file Yaw sector lookup: first threshold at or above the wrapped azimuth, else sector 0 (design 4.3). */
import type { SectorTable } from '@zilo/pose3d-format/types/facet';

/** Sector index of `azimuth` (degrees, any range; wrapped to [0, 360)) in `table`. */
export function sectorOf(azimuth: number, table: SectorTable): number {
  const a = ((azimuth % 360) + 360) % 360;
  const i = table.thresholds.findIndex((t) => t >= a);
  return i < 0 ? 0 : i;
}
